import { transport } from '@opengov/app-core/transport';
import { useMutation } from '@tanstack/react-query';
import { customReportsQueryKeys } from './customReportsQueryKeys';

type Params = {
  storyId: string;
  storyContentId: string;
  spreadsheetId: string;
  namedRangeId: string;
};

async function deleteSpreadsheetTable({ storyId, storyContentId, spreadsheetId, namedRangeId }: Params): Promise<void> {
  return transport
    .url(
      `/api/stories/v1/stories/${storyId}/content/${storyContentId}/spreadsheet-table?spreadsheetId=${spreadsheetId}&namedRangeId=${namedRangeId}`
    )
    .delete()
    .json();
}

export function useDeleteSpreadsheetTable({ storyId, storyContentId }: { storyId: string; storyContentId: string }) {
  return useMutation({
    mutationKey: customReportsQueryKeys.deleteSpreadsheetTable({ storyId, storyContentId }),
    mutationFn: ({ spreadsheetId, namedRangeId }: { spreadsheetId: string; namedRangeId: string }) =>
      deleteSpreadsheetTable({ storyId, storyContentId, spreadsheetId, namedRangeId })
  });
}
